import { render, staticRenderFns } from "./EditarCliente.vue?vue&type=template&id=6918e660&"
import script from "./EditarCliente.vue?vue&type=script&lang=js&"
export * from "./EditarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports